import { NationalCommitteesCatalogRedirect } from "./_NationalCommitteesRedirect";

export default function ActiveCommitteesPage() {
  return <NationalCommitteesCatalogRedirect status="active" />;
}
